import { render, staticRenderFns } from "./CouponPreviewBenefit.vue?vue&type=template&id=7ec8124a&scoped=true&"
import script from "./CouponPreviewBenefit.vue?vue&type=script&lang=js&"
export * from "./CouponPreviewBenefit.vue?vue&type=script&lang=js&"
import style0 from "./CouponPreviewBenefit.vue?vue&type=style&index=0&id=7ec8124a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec8124a",
  null
  
)

export default component.exports